import HiveAccoutCreation from 'components/Dashboard/HiveAccountCreator/HiveAccoutCreation';
import { useQuery } from '@apollo/client';
import { HIVE_ACCOUNT_CREATABLE } from '../../../helpers/graphql/hive';
import HiveBtn from 'components/About/Earn/HiveBtn';
import DashboardCard from '../DashboardCard';
import { GET_HIVE_USERNAME } from 'helpers/graphql/profile';
import { getUser } from 'helpers/token';

export default function HiveAccountCreatable() {
  const { data } = useQuery(HIVE_ACCOUNT_CREATABLE, {
    fetchPolicy: 'network-only',
  });
  const hiveUser = useQuery(GET_HIVE_USERNAME, {
    variables: { username: getUser() },
    fetchPolicy: 'network-only',
  });
  if (
    hiveUser &&
    hiveUser.data &&
    hiveUser.data.profile &&
    hiveUser.data.profile.hive
  )
    return (
      <div className="container d-flex justify-content-center mt-5 mb-5">
        <div style={{ maxWidth: '800px' }}>
          <DashboardCard
            titleSize="h5"
            title="Create a free Hive account"
            content={
              <div className="tw-p-2">
                You are already a Hive user. We only provide a free Hive account
                to new users.
              </div>
            }
          />
        </div>
      </div>
    );
  if (data) {
    if (data.hiveAccountCreatable) return <HiveAccoutCreation />;
    return (
      <div className="container d-flex justify-content-center mt-5 mb-5">
        <div style={{ maxWidth: '800px' }}>
          <DashboardCard
            titleSize="h5"
            title="Create a free Hive account"
            content={
              <div className="postcontent">
                You are currently not eligble to create a free Hive account
                through TravelFeed. Usually, this is unlocked a few days after
                you publish your first post. If you can&apos;t wait, you can
                create a Hive account here:
                <div className="tw-pt-2">
                  <a
                    href="https://signup.hive.io/"
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                  >
                    <HiveBtn text="Create a free Hive account" />
                  </a>
                </div>
              </div>
            }
          />
        </div>
      </div>
    );
  }
  return <></>;
}
